import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiSkeleton } from '@taiga-ui/kit';
import { BasePhotoModule } from '@src/app/shared';

import { PhotoComponent } from './photo.component';

@NgModule({
  declarations: [PhotoComponent],
  imports: [CommonModule, BasePhotoModule, TuiSkeleton],
  exports: [PhotoComponent],
})
export class PhotoModule {}
